import { LOGOUT_USER } from '../Types';
import axios from 'axios';
/**
 * Logout the user
 */
export const logout = () => {
  return dispatch => {
    dispatch({
      type: LOGOUT_USER,
      request: async () => {
        const result = await axios.post('/logout');

        return result;
      }
    });
  };
};
